import {
    CompetitionDetailVm,
    CompetitionsClient,
    UpdateCompetitionCommandOfCompetition,
} from '../../utils/api';

function detailToUpdateCommand(
    detail: CompetitionDetailVm,
    season: string
): UpdateCompetitionCommandOfCompetition {
    return new UpdateCompetitionCommandOfCompetition({
        id: detail.id,
        name: detail.name,
        nameUniversal: detail.nameUniversal,
        shortName: detail.shortName,
        description: detail.description,
        extraCompetitionStages: detail.extraCompetitionStages,
        season,
        startDate: detail.startDate,
        endDate: detail.endDate,
        venue: detail.venue,
        address: detail.address,
        web: detail.web,
        email: detail.email,
        phone: detail.phone,
        facebook: detail.facebook,
        youtube: detail.youtube,
        twitter: detail.twitter,
        instagram: detail.instagram,
        logo: detail.logo,
        matchLogTemplateLanguage: detail.matchLogTemplateLanguage ?? 'en',
        isPro: detail.isPro,
        isInternational: detail.isInternational,
        gameLogPinConfirmationRequired: detail.gameLogPinConfirmationRequired,
        federationId: detail.federationId,
        categoryId: detail.categoryId,
        competitionTypeId: detail.competitionTypeId,
        countryId: detail.countryId,
        cityId: detail.cityId,
    });
}

export async function applyBatchSeasonToCompetitions(
    competitionIds: number[],
    season: string
): Promise<{ ok: number; failed: number }> {
    const client = new CompetitionsClient();
    const trimmedSeason = season.trim();

    const settled = await Promise.allSettled(
        competitionIds.map(async (competitionId: number) => {
            const detail = await client.getById(competitionId);
            const cmd = detailToUpdateCommand(detail, trimmedSeason);
            await client.update(competitionId, cmd);
        })
    );

    const failed = settled.filter((s) => s.status === 'rejected').length;
    const ok = settled.length - failed;
    return { ok, failed };
}
